"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CsButton = void 0;
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var react_1 = __importDefault(require("react"));
var CsButton_styles_1 = require("./CsButton.styles");
exports.CsButton = react_1.default.memo(function (_a) {
    var _b;
    var solid = _a.solid, color = _a.color, fileUpload = _a.fileUpload, title = _a.title, style = _a.style, small = _a.small, fullwidth = _a.fullwidth, label = _a.label, children = _a.children, onClick = _a.onClick, id = _a.id, className = _a.className, disabled = _a.disabled, textButton = _a.textButton;
    var handleClick = function () {
        var _a;
        if (onClick) {
            onClick((_a = id !== null && id !== void 0 ? id : label) !== null && _a !== void 0 ? _a : '');
        }
    };
    return (react_1.default.createElement(Button_1.default, { component: fileUpload ? 'span' : 'button', style: __assign({}, style), className: className ? className : '', title: (_b = title !== null && title !== void 0 ? title : label) !== null && _b !== void 0 ? _b : undefined, variant: solid ? 'contained' : !textButton ? 'outlined' : undefined, onClick: handleClick, size: small ? 'small' : 'medium', fullWidth: fullwidth, disabled: disabled, color: color ? color : 'primary' },
        children,
        react_1.default.createElement("span", { style: children && label ? CsButton_styles_1.csButtonContentPadding : undefined }, label)));
});
exports.CsButton.displayName = 'CsButton';
exports.default = exports.CsButton;
//# sourceMappingURL=CsButton.js.map